export default [
  {
    id: 1,
    author: "Charles Imo",
    role: "Director, Amba Global Freight",
    quote: "Passionate about what he does. Will go an extra mile to ensure client satisfaction",
  },
  {
    id: 2,
    author: "David Kavunja",
    role: "Founder, Safetyaro LTD",
    quote: "His good communication and dedication to understand the client moved me.",
  },
  // {
  //   id: 3,
  //   author: "J.K Gitau",
  //   role: "CEO Networks & Cicuits",
  //   quote: "Worked with him for quite sometime and he has never disappointed me.",
  // },
];
